import { render, staticRenderFns } from "./AuthenticationCallback.vue?vue&type=template&id=258da641"
import script from "./AuthenticationCallback.vue?vue&type=script&lang=js"
export * from "./AuthenticationCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports